import React, { useState } from 'react';
import { Menu } from 'antd';
import { UserOutlined, LogoutOutlined, SettingOutlined } from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';
import { useUser } from '../context';
import { ROUTES, TOKEN_KEY, UserType } from './common';
import { NotificationSettingsModal } from './Notifications/NotificationSettingsModal';

const UserDropdownMenu = () => {
  const navigate = useNavigate();
  const { user, setUser } = useUser();
  const [settingsOpen, setSettingsOpen] = useState(false);
  
  console.log("User data in dropdown:", user);

  const handleLogout = () => {
    localStorage.removeItem(TOKEN_KEY);
    // Clears a legacy cached-user key some browsers still carry from an old
    // build - nothing writes it anymore, but clean it up defensively so it
    // can't leak a previous account's identity into the next login.
    localStorage.removeItem("user");
    setUser(undefined);
    navigate(ROUTES.LANDING);
  };

  const handleProfileClick = () => {
    navigate(ROUTES.CANDIDATE_PROFILE);
  };

  return (
    <>
      <Menu>
        <Menu.Item key="email" disabled>
          {user?.email}
        </Menu.Item>
        <Menu.Item key="category" disabled>
          Role: {user?.category || "Unknown"}
        </Menu.Item>
        <Menu.Divider />
        {/* Show profile for candidates */}
        {user?.category === UserType.CANDIDATE && (
          <Menu.Item key="profile" icon={<UserOutlined />} onClick={handleProfileClick}>
            Profile
          </Menu.Item>
        )}
        <Menu.Item
          key="notification-settings"
          icon={<SettingOutlined />}
          onClick={() => setSettingsOpen(true)}
        >
          Notification Settings
        </Menu.Item>
        <Menu.Item key="logout" icon={<LogoutOutlined />} onClick={handleLogout}>
          Logout
        </Menu.Item>
      </Menu>
      <NotificationSettingsModal open={settingsOpen} onClose={() => setSettingsOpen(false)} />
    </>
  );
};

export default UserDropdownMenu; 